import { Invite } from 'types/Invite';
import { AffiliationRole } from 'utils/constants';
import HttpClient, { HTTPClientParameters } from './HTTPClient';

export type InviteForm = {
    first_name: string;
    last_name: string;
    email: string;
    role: AffiliationRole;
};

type SendInvitePayload = InviteForm & { organization: number };

type InviteClientParameters = HTTPClientParameters;

class InviteClient extends HttpClient {
    constructor(params: InviteClientParameters) {
        super(params);
        this.headers.set('Content-Type', 'application/json');
    }

    getInvites(orgId: number): Promise<Invite[]> {
        return this.get(`invitations?organization=${orgId}`);
    }

    sendInvite(invitation: SendInvitePayload): Promise<Invite> {
        return this.post(`invitations/`, invitation);
    }

    deleteInvite(invitationId: number): Promise<void> {
        return this.delete(`invitations/${invitationId}/`);
    }
}

export default InviteClient;
